import React, { useState } from 'react';
import { translate } from '../../../Services/translation';
import CustomDropdown from './CustomDropdown';

const CountriesModalComponent = ({
  modalTitle,
  modalText,
  modalCountry,
  modalCurrentCountry,
  onSelect,
}) => {
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedCurrentCountry, setSelectedCurrentCountry] = useState('');

  if (
    !modalCountry ||
    typeof modalCountry !== 'object' ||
    Array.isArray(modalCountry)
  ) {
    return null;
  }

  if (
    !modalCurrentCountry ||
    typeof modalCurrentCountry !== 'object' ||
    Array.isArray(modalCurrentCountry)
  ) {
    return null;
  }

  const modalCountryOptions = Object.entries(modalCountry).map(
    ([value, label]) => ({
      value: value,
      label: label,
    })
  );

  const modalCurrentCountryOptions = Object.entries(modalCurrentCountry).map(
    ([value, label]) => ({
      value: value,
      label: label,
    })
    );
  const isSubmitDisabled =
    selectedCountry === '' || selectedCurrentCountry === '';

  const handleSubmit = () => {
    if (!isSubmitDisabled) {
      onSelect(selectedCountry, selectedCurrentCountry);
    }
  };

  return (
    <div className="countries-modal">
      <p className="countries-modal--title">{modalTitle}</p>
      <div
        className="countries-modal--text"
        dangerouslySetInnerHTML={{ __html: modalText }}
      />
      <div className="countries-modal--dropdown-container">
        <label
          htmlFor="modalCountry"
          className="countries-modal--dropdown-container--label"
        >
          {translate('investment-page-modal-select-country')}
        </label>
        <CustomDropdown
          options={modalCountryOptions}
          onSelect={setSelectedCountry}
          selectedValue={selectedCountry}
        />
      </div>

      <div className="countries-modal--dropdown-container">
        <label
          htmlFor="modalCurrentCountry"
          className="countries-modal--dropdown-container--label"
        >
          {translate('investment-page-modal-select-current-country')}
        </label>
        <CustomDropdown
          options={modalCurrentCountryOptions}
          onSelect={setSelectedCurrentCountry}
          selectedValue={selectedCurrentCountry}
        />
      </div>
      <button
        onClick={handleSubmit}
        disabled={isSubmitDisabled}
        className="countries-modal--button"
      >
        {translate('investment-page-modal-accept-all')}
      </button>
    </div>
  );
};

export default CountriesModalComponent;
